import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { AreaAcopioSolidosSchema } from "../data/AreaAcopioSolidosSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import ObjectField from "./controls/ObjectField";
import TextField from "./controls/TextField";
import {
  getTouchedFromSchema,
  isInvalid,
  touchFieldsFromErrors,
} from "../utils/forms";
import AmmountField from "./controls/AmmountField";
import SelectField from "./controls/SelectField";
import QuestionField from "./controls/QuestionField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";

export function AreaAcopioSolidoForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  disabled,
  unidadDimensionGrano,
  unidadCantidad,
  unidadSuperficie,
  cercosPerimetrales,
}) {
  const { t } = useTranslation();
  const initialTouched =
    page >= 0 ? getTouchedFromSchema(value, AreaAcopioSolidosSchema) : {};
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnMount={page >= 0}
      initialTouched={initialTouched}
      validationSchema={AreaAcopioSolidosSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(areaAcopioSolidoForm) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("areaAcopioSolidoForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <ObjectField
                id="areaAcopioSolido_solido"
                name="solido"
                value={areaAcopioSolidoForm.values?.solido}
                onChange={(event) => areaAcopioSolidoForm.handleChange(event)}
                disabled={disabled}
              >
                {({ value, setProperty, disabled }) => (
                  <Grid>
                    <Row>
                      <Col>
                        <TextField
                          id="areaAcopioSolido_solido_material"
                          name="solido.material"
                          label={t("solidoAcopiado.material")}
                          value={value?.material}
                          onChange={(event) => {
                            event.preventDefault();
                            setProperty("material", event.target.value);
                          }}
                          isInvalid={isInvalid(
                            "solido.material",
                            areaAcopioSolidoForm,
                          )}
                          error={t(
                            areaAcopioSolidoForm.errors.solido?.material,
                          )}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4}>
                        <AmmountField
                          id="areaAcopioSolido_solido_dimensionGrano"
                          name="solido.dimensionGrano"
                          label={t("solidoAcopiado.dimensionGrano")}
                          value={value?.dimensionGrano}
                          onChange={(event) => {
                            event.preventDefault();
                            setProperty("dimensionGrano", event.target.value);
                          }}
                          unit={unidadDimensionGrano}
                          isInvalid={isInvalid(
                            "solido.dimensionGrano",
                            areaAcopioSolidoForm,
                          )}
                          error={t(
                            areaAcopioSolidoForm.errors.solido?.dimensionGrano,
                          )}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  </Grid>
                )}
              </ObjectField>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <AmmountField
                id="areaAcopioSolido_cantidad"
                name="cantidad"
                label={t("areaAcopioSolido.cantidad")}
                value={areaAcopioSolidoForm.values?.cantidad}
                onChange={(event) => areaAcopioSolidoForm.handleChange(event)}
                unit={unidadCantidad}
                isInvalid={isInvalid("cantidad", areaAcopioSolidoForm)}
                error={t(areaAcopioSolidoForm.errors.cantidad)}
                disabled={disabled}
              />
            </Col>
            <Col lg={4}>
              <AmmountField
                id="areaAcopioSolido_superficie"
                name="superficie"
                label={t("areaAcopioSolido.superficie")}
                value={areaAcopioSolidoForm.values?.superficie}
                onChange={(event) => areaAcopioSolidoForm.handleChange(event)}
                unit={unidadSuperficie}
                isInvalid={isInvalid("superficie", areaAcopioSolidoForm)}
                error={t(areaAcopioSolidoForm.errors.superficie)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <SelectField
                id="areaAcopioSolido_cercoPerimetral"
                name="cercoPerimetral"
                label={t("areaAcopioSolido.cercoPerimetral")}
                value={areaAcopioSolidoForm.values?.cercoPerimetral}
                onChange={(event) => areaAcopioSolidoForm.handleChange(event)}
                options={cercosPerimetrales}
                labelAttr="nombre"
                valueAttr="codigo"
                emptyLabel="..."
                isInvalid={isInvalid("cercoPerimetral", areaAcopioSolidoForm)}
                error={t(areaAcopioSolidoForm.errors.cercoPerimetral)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <QuestionField
                id="areaAcopioSolido_conCerramientoSuperior"
                name="conCerramientoSuperior"
                label={t("areaAcopioSolido.conCerramientoSuperior")}
                value={areaAcopioSolidoForm.values?.conCerramientoSuperior}
                onChange={(event) => areaAcopioSolidoForm.handleChange(event)}
                isInvalid={isInvalid(
                  "conCerramientoSuperior",
                  areaAcopioSolidoForm,
                )}
                error={t(areaAcopioSolidoForm.errors.conCerramientoSuperior)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={7}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={5}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("areaAcopioSolidoForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("areaAcopioSolidoForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("areaAcopioSolidoForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    areaAcopioSolidoForm.validateForm().then((errors) => {
                      if (
                        touchFieldsFromErrors(errors, areaAcopioSolidoForm)
                      ) {
                        return;
                      }
                      areaAcopioSolidoForm.submitForm();
                    });
                  }}
                  disabled={disabled}
                />
                {page === -1 && pages > 0 && (
                  <Button
                    sm
                    variant="default"
                    value={t("areaAcopioSolidoForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(0);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
